import React, { createContext, useCallback, useState } from "react";

export const SidePanelContext = createContext({});

export const SidePanelProvider = ({ children }) => {
    const [isSidePanelOpen, setSidePanelOpen] = useState(false);
    const [hasMobileBanner, setHasMobileBanner] = useState(false);
    const [isSalesSample, setIsSalesSample] = useState(false);

    const handleSidePanelToggle = useCallback((isOpen) => setSidePanelOpen(isOpen), []);

    const handleMobileBanner = useCallback((details) => setHasMobileBanner(details), []);

    const handleSalesSample = useCallback((isSample) => setIsSalesSample(isSample), []);

    return (
        <SidePanelContext.Provider
            value={{
                onToggle: handleSidePanelToggle,
                isSidePanelOpen,
                onEnableHeroFeature: handleMobileBanner,
                hasMobileBanner,
                onDisableCodingReject: handleSalesSample,
                isSalesSample,
            }}
        >
            {children}
        </SidePanelContext.Provider>
    );
};
